import { render, staticRenderFns } from "./ManagerBalances.vue?vue&type=template&id=41d9c4ce&scoped=true"
import script from "./ManagerBalances.vue?vue&type=script&lang=js"
export * from "./ManagerBalances.vue?vue&type=script&lang=js"
import style0 from "./ManagerBalances.vue?vue&type=style&index=0&id=41d9c4ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d9c4ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
